import { SectionBackground } from "../sectionBackground/SectionBackground";
import "./SelectDateAndTimeExpanded.css";
import { DatesList } from "../datesList/DatesList";
import { SelectCourtType } from "../selectCourtType/SelectCourtType";
import { SelectTimeSlot } from "../selectTimeSlot/SelectTimeSlot";
import {
  useCourtBookingStore,
  useSectionStore,
} from "../../stores/StoreContext";
import { Button } from "../button/Button";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { MinimumPlayingTime } from "../minimumPlayingTime/MinimumPlayingTime";

export const SelectDateAndTimeExpanded = observer(() => {
  const sectionStore = useSectionStore();
  const courtBookingStore = useCourtBookingStore();

  return (
    <SectionBackground
      indicator={1}
      title={"Select the day and time you can play"}>
      <DatesList />
      <SelectCourtType />
      {courtBookingStore.timeSlotsResponse ? (
        <>
          <SelectTimeSlot />
          <MinimumPlayingTime />
          <div className="button-container">
            <Button
              text={"Next"}
              onPress={() => {
                sectionStore.onDateTimeDone();
              }}
              disabled={courtBookingStore.selectedTimeSlots.length === 0}
              btnStyle={{
                width: 162,
                height: 56,
                backgroundColor: Colors.darkBrown,
                alignSelf: "center",
                marginTop: courtBookingStore.timeSlotsResponse ? 0 : 15,
                paddingBottom: 5,
              }}
              textStyle={{
                color: "white",
                fontWeight: 600,
                fontSize: 14,
              }}
            />
          </div>
        </>
      ) : null}
    </SectionBackground>
  );
});
